// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30sUr","controls":"styles_controls__19th5","charLimit":"styles_charLimit__1C0xp","input":"styles_input__ElRBd","send":"styles_send__2MV9p"};